const PERMISSION_DENIED = 1
const POSITION_UNAVAILABLE = 2;
const TIMEOUT = 3;

export function getLocation() {
    return new Promise((resolve, reject) => {
        function success(position) {
            const latLng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            resolve(latLng);
        }
        function error(err) {
            if (err.code === TIMEOUT || err.code === POSITION_UNAVAILABLE) {
                resolve(null);
            } else if (err.code === PERMISSION_DENIED) {
                console.error("User denied location permission");
                reject();
            }
        }
        navigator.geolocation.getCurrentPosition(success, error);
    })
}